import Text from '@cartwhl/ui/base/Text';

interface YouTubeEmbedProps {
  videoId: string;
  caption?: string;
  /** When true, renders without breakout styling (used in hero) */
  bare?: boolean;
}

export default function YouTubeEmbed({
  videoId,
  caption,
  bare,
}: YouTubeEmbedProps) {
  const embed = (
    <div className="relative w-full overflow-hidden rounded-2xl px-4 pt-[56.25%] lg:px-0">
      <iframe
        className="absolute inset-0 h-full w-full"
        src={`https://www.youtube.com/embed/${videoId}`}
        title="YouTube video"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );

  if (bare) {
    return embed;
  }

  return (
    <figure className="article-breakout my-8 lg:my-12">
      {embed}
      {caption && (
        <figcaption className="article-caption mx-auto mt-3 px-4">
          <Text
            as="span"
            variant="web/body/medium/xs"
            className="text-tertiary"
          >
            {caption}
          </Text>
        </figcaption>
      )}
    </figure>
  );
}
